<template>
    <div class="field-inspectors-list" v-if="authorize('admin') || authorize('is_inspector')">
        <a href="#" v-for="inspector in inspectors" :key="inspector.id" @click="select(inspector)">
            <div class="inspector"
                 :class="{'is-selected' : (value && value.id == inspector.id)}"
                 data-toggle="tooltip"
                 data-placement="top"
                 :title="tooltipTitle(inspector)">

                <div class="image">
                    <img :src="inspector.avatar" :alt="inspector.name">
                </div>

                <div class="counter" v-if="isFieldInspection && inspector.field_inspections_as_inspector_count">
                    <span v-if="(inspector.field_inspections_as_inspector_count < 99)" v-text="inspector.field_inspections_as_inspector_count"></span>
                    <span v-else>99+</span>
                </div>
                <div class="counter" v-if="!isFieldInspection && inspector.field_audits_as_inspector_count">
                    <span v-if="(inspector.field_audits_as_inspector_count < 99)" v-text="inspector.field_audits_as_inspector_count"></span>
                    <span v-else>99+</span>
                </div>

            </div>
        </a>
        <div v-if="value">
            <button class="btn btn-blank" @click="select(null)">
                <i class="fa fa-times text-danger mr-0"></i>
            </button>
        </div>
    </div>
</template>
<script>
    export default {

        props: {
            value: {
                required: true,
            },
            inspectors: {
                type: Array,
                require: true,
            }
        },

        mounted() {
            $('[data-toggle="tooltip"]').tooltip()
        },

        methods: {
            select(inspector) {
                this.$emit('input', inspector);
            },

            tooltipTitle(inspector) {
                if (this.isFieldInspection) {
                    return `${inspector.name} (${inspector.field_inspections_as_inspector_count})`;
                }
                return `${inspector.name} (${inspector.field_audits_as_inspector_count})`;
            }
        },

        computed: {

            isFieldInspection() {
                return window.location.pathname.indexOf("field-inspections") > -1;
            }
        }
    }
</script>
